import type { Business } from '@/lib/schemas/business';

/**
 * The capabilities the API reports on a business, as the web reads them.
 *
 * Never derived from the tier here. The API decides what a plan includes, and
 * a second copy of that table in the client is a second thing to keep in step
 * — it sends the answer, and this reads it.
 */
export type Capability =
  | 'RESPOND'
  | 'RESOLVE'
  | 'BASIC_PROFILE'
  | 'IN_APP_ALERTS'
  | 'INSTANT_EMAIL_ALERTS'
  | 'BRANDING'
  | 'ANALYTICS'
  | 'EXPORT'
  | 'MONTHLY_REPORT'
  | 'POST_AS_BUSINESS';

export function can(business: Pick<Business, 'capabilities'>, capability: Capability): boolean {
  return business.capabilities.includes(capability);
}
